<template>
  <div class="rpg-pd-5">
    <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
      <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
      <span class="rpg-gray">（当前项目）</span>
    </div>
    <div class="rpg-pd-5-10 rpg-label">offer反馈</div>
    <div class="rpg-pd-5-10">
      <div>人选意向及对offer的反馈：</div>
      <div>
        <el-radio v-model="result" label="接受">接受</el-radio>
        <el-radio v-model="result" label="有顾虑">有顾虑</el-radio>
        <el-radio v-model="result" label="拒绝">拒绝</el-radio>
      </div>
      <el-input
        type="textarea"
        rows="3"
        v-model="radishFeedback"
        placeholder="填写客人选对于客户公司的意向；以及对于offer的反馈；"
      ></el-input>
    </div>
    <div class="rpg-pd-5-10"><span class="rpg-btn rpg-btn-outline" @click="showTmp">点击按照模板填写</span></div>
    <div class="rpg-pd-5-10">
      <div>客户&客户经理对人选反馈：</div>
      <el-input
        type="textarea"
        rows="3"
        v-model="clientFeedback"
        placeholder="客户以及客户经理对于offer的反馈，以及相关疑问的回答"
      ></el-input>
    </div>
    <div class="rpg-pd-5-10 rpg-text-center">
      <el-button size="mini" type="primary" @click="handleConfirm">提交</el-button>
    </div>
    <OfferFeedBackTemplate ref="OfferFeedBackTemplate" @confirm="confirmTemplate"></OfferFeedBackTemplate>
  </div>
</template>
<script>
import OfferFeedBackTemplate from './offer-feedback-template'
import project_notify from '../constant/project_notify'
export default {
  components: { OfferFeedBackTemplate },
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      result: '接受',
      clientFeedback: '',
      radishFeedback: '',
      rid: '',
      pid: '',
      offer: undefined,
      interview: undefined,
      feedbackObj: undefined,
    }
  },
  async mounted() {
    this.rid = this.radish.rid || this.radish._id
    this.pid = this.project._id
    this.clientFeedback = ''
    this.radishFeedback = ''
    // 获取offer数据
    const res = await app.service('radish').findOffer({ rid: this.rid, pid: this.pid })
    if (res.status === 'success') {
      if (res.data.length > 0) {
        this.offer = res.data[0]
        if (res.data[0].offer反馈) {
          this.result = res.data[0].offer反馈.意向 || '接受'
          this.clientFeedback = res.data[0].offer反馈.客户经理反馈 || ''
          this.radishFeedback = res.data[0].offer反馈.候选人反馈 || ''
        }
        // 获取面试
        const res2 = await app.service('radish').findInterview({ rid: this.rid, pid: this.pid })
        if (res2.status == 'success') {
          if (res2.data.length > 0) {
            this.interview = res2.data[0]
          }
        }
      } else {
        this.$message.error('未找到对应offer数据')
        this.onConfirm()
      }
    } else {
      this.$message.error(res.msg)
    }
  },
  methods: {
    async handleConfirm() {
      const user = app.user.account
      const time = Date.now()
      const dt = {
        offer反馈: {
          意向: this.result,
          候选人反馈: this.radishFeedback,
          客户经理反馈: this.clientFeedback,
          时间: time,
          顾问: user,
        },
      }
      if (this.feedbackObj) {
        dt.反馈模板 = this.feedbackObj
      }
      const res = await app.service('radish').updateOffer({ rid: this.rid, pid: this.pid, data: dt, type: 'feedback' })
      if (res.status == 'success') {
        this.onConfirm()
        this.$message.success('操作成功')

        const content = {
          人选意向: this.result,
          客户和客户经理对人选反馈: this.clientFeedback,
          人选对公司反馈: this.radishFeedback,
        }
        project_notify.sendMessage(this.rid, this.pid, '-offer反馈', 'offer反馈', content)
      } else {
        this.$message.error(res.msg)
      }
    },
    showTmp() {
      let formData = {
        候选人: this.offer.候选人,
        推荐顾问: this.offer.顾问,
      }
      if (this.offer.反馈模板) {
        formData = this.offer.反馈模板
      } else if (this.interview && this.interview.反馈模板) {
        const feed = this.interview.反馈模板
        Object.assign(formData, {
          人选意向: feed.人选意向,
          人选诉求: feed.人选诉求,
          人选目前薪酬: feed.人选目前薪酬,
          人选目前职级: feed.人选目前职级,
          风险点: feed.风险点,
          离职周期: feed.离职周期,
          预计到岗时间: feed.预计到岗时间,
          人选目前其他offer: feed.人选目前其他offer,
        })
      }
      this.$refs.OfferFeedBackTemplate.open(formData)
    },
    confirmTemplate({ text, obj }) {
      this.radishFeedback = text
      this.feedbackObj = obj
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
